import type React from 'react';
import {useEffect} from 'react';

function useOnEscape(
  ref: React.RefObject<HTMLElement | null>,
  handler: (e: KeyboardEvent) => void
) {
  useEffect(() => {
    const listener = (e) => {
      if (e.key === 'Escape' && ref && ref.current) {
        handler(e);
      }
    };

    global.document.addEventListener('keydown', listener);

    return () => {
      global.document.removeEventListener('keydown', listener);
    };
  }, [ref, handler]);
}

export default useOnEscape;
